import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useFormHook from '@shared/hooks/useFormHook';

const CountryModal = ({ onClose, onConfirm, editData = null }) => {
    const { modalRef } = useFormHook({}, onClose);
    const { t } = useTranslation();
    
    const countrySchema = yup.object({
        countryNameBg: yup.string()
            .required(t('validation.countryName.required'))
            .min(1, t('validation.countryName.minLength'))
            .max(100, t('validation.countryName.maxLength')),
        countryName: yup.string()
            .required(t('validation.countryName.required'))
            .min(1, t('validation.countryName.minLength'))
            .max(100, t('validation.countryName.maxLength')),
        countryCode: yup.string()
            .required(t('validation.countryCode.required'))
            .min(1, t('validation.countryCode.minLength'))
            .max(2, t('validation.countryCode.maxLength'))
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(countrySchema),
        defaultValues: {
            countryNameBg: editData?.countryNameBg || '',
            countryName: editData?.countryName || '',
            countryCode: editData?.countryCode || ''
        }
    });

    const isEdit = Boolean(editData);
    const title = isEdit ? t('regions.modal.editCountry') : t('regions.modal.addCountry');

    const onSubmit = (data) => {
        onConfirm(data);
    };

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">{title}</h4>
                        <form id="countryForm" className="region-form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-group">
                                <span className="span-bold">{t('regions.modal.countryNameBg')} <span className="required">*</span></span>
                                <input 
                                    type="text"
                                    className={`form-control ${errors.countryNameBg ? 'is-invalid' : ''}`}
                                    placeholder={t('regions.modal.countryNameBgPlaceholder')}
                                    {...register('countryNameBg')}
                                />
                                {errors.countryNameBg && (
                                    <div className="invalid-feedback">
                                        {errors.countryNameBg.message}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <span className="span-bold">{t('regions.modal.countryName')} <span className="required">*</span></span>
                                <input 
                                    type="text"
                                    className={`form-control ${errors.countryName ? 'is-invalid' : ''}`}
                                    placeholder={t('regions.modal.countryNamePlaceholder')}
                                    {...register('countryName')}
                                />
                                {errors.countryName && (
                                    <div className="invalid-feedback">
                                        {errors.countryName.message}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <span className="span-bold">{t('regions.modal.countryCode')} <span className="required">*</span></span>
                                <input 
                                    type="text"
                                    className={`form-control ${errors.countryCode ? 'is-invalid' : ''}`}
                                    placeholder={t('regions.modal.countryCodePlaceholder')}
                                    {...register('countryCode')}
                                />
                                {errors.countryCode && (
                                    <div className="invalid-feedback">
                                        {errors.countryCode.message}
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" form="countryForm" className="btn btn-primary">
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CountryModal; 